import { observable, action, computed, toJS } from 'mobx';
import { ReqInputMsg, Addition, callCmd } from 'lib/reqInputMsg';
import { notification } from 'antd';

export default class BoardStore {
  constructor(root) {
    this.root = root;
  }

  //----------------------------------
  /* Mainstore에서 세션만료 처리하기위해 */
  @observable
  _commonStoreInfo = null;

  @computed
  get commonStoreInfo() {
    return this._commonStoreInfo;
  }

  @action
  setCommonStoreInfo = (storeInfo) => {
    this._commonStoreInfo = storeInfo;
  };

  //----------------------------------
  /* 화면 변경 목록, 상세보기, 수정, 추가 */
  @observable
  _viewMode = 'list';

  @computed
  get viewMode() {
    return this._viewMode;
  }

  @action
  onViewMode = (mode) => {
    // list, detail, add, mod
    this._viewMode = mode;
    if (mode === 'add') {
      this._detailData = null;
    }
  };
  //----------------------------------
  /* 검색조건 */
  @observable 
  _valCondition = {
    schText: '',
    selValue: 'A',

    pageIdx: 1
  };

  @computed
  get valCondition() {
    return this._valCondition;
  }

  @action
  onChangValue = (dataNm, dataVal) => {
    this._valCondition = {
      ...this._valCondition,
      [dataNm]: dataVal
    };
  };
  //----------------------------------
  /* 상세데이터 */
  @observable
  _detailData = null;

  @computed
  get detailData() {
    return this._detailData;
  }
  //----------------------------------
  @observable
  _noticeList = [];

  @computed
  get noticeList() {
    return this._noticeList;
  }

  @observable
  _pageInfo = null;

  @computed
  get pageInfo() {
    return this._pageInfo;
  }
  //----------------------------------
  @action
  onClear = () => {
    this._viewMode = 'list';
    
    this._noticeList = [];
    this._pageInfo = null;
    this._detailData= null;
    this._valCondition = {
      schText: '',
      selValue: 'A',
      pageIdx: 1
    };
  };

  @action
  disNoticeList = async (pageIdx) => {
    if (pageIdx !== undefined && pageIdx !== null && this._valCondition.pageIdx !== pageIdx) {
      this._valCondition.pageIdx = pageIdx;
    }

    let addition = new Addition();
    addition.setCmdName('DIS-NOTICE-LIST');
    addition.setPageYn('Y');
    addition.setPageIndex(this._valCondition.pageIdx);
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'schText', paraValue: this._valCondition.schText});
    reqInputMsg.addParam({paraName: 'selValue', paraValue: this._valCondition.selValue});
    
    return await callCmd(reqInputMsg, 'board')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._noticeList = res.result;
          this._pageInfo = res.addition;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._noticeList = [];
          this._pageInfo = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._noticeList = [];
        this._pageInfo = null;
        console.log('error', error);
      });
  };

  @action
  disNoticeDetail = async (bodId) => {
    let addition = new Addition();
    addition.setCmdName('DIS-NOTICE-DETAIL');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'bodId', paraValue: bodId});

    return await callCmd(reqInputMsg, 'board')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result.length > 0) {
            this._detailData = res.result[0];
            this._viewMode = 'detail';
          } else {
            notification.error({placement: 'bottomLeft', message: `상세보기가 실패하였습니다.`, duration: 2});
            this._detailData = null;
          }
          
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`상세보기가 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._detailData = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`상세보기가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._detailData = null;
        console.log('error', error);
      });
  };

  @action
  addNoticeInfo = async (data) => {
    if (data.bodAttachedList !== undefined && data.bodAttachedList !== null
      && data.bodAttachedList.length > 0 && Array.isArray(toJS(data.bodAttachedList))) {
        let vFileId = '';
        data.bodAttachedList.map((item, idx)=>{return (
          (idx !== 0) && (vFileId = vFileId + ','),
          
          (item.fileId !== undefined && item.fileId !== null) &&
            (vFileId = vFileId + "'" + item.fileId + "'")
          
        )});
        data.bodAttachedFile = vFileId;
    }

    // data를 name value로 수정
    let paramData = [];
    Object.keys(data).map((key)=>{return (
      (key !== 'bodAttachedList') &&
        (paramData.push({
          paraName: key, paraValue: data[key]
        }))
    )});

    // console.log(paramData);

    let addition = new Addition();
    addition.setCmdName('ADD-NOTICE-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.setParamList(paramData);
    
    return await callCmd(reqInputMsg, 'board')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`등록이 성공하였습니다.`, duration: 2});
            this._viewMode = 'list';
            this.disNoticeList();
          } else {
            notification.success({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  @action
  modNoticeInfo = async (data) => {
    if (data.bodAttachedList !== undefined && data.bodAttachedList !== null
      && data.bodAttachedList.length > 0 && Array.isArray(toJS(data.bodAttachedList))) {
        let vFileId = '';
        data.bodAttachedList.map((item, idx)=>{return (
          (idx !== 0) && (vFileId = vFileId + ','),
          
          (item.fileId !== undefined && item.fileId !== null) &&
            (vFileId = vFileId + "'" + item.fileId + "'")
        )});
        data.bodAttachedFile = vFileId;
    } else {
      data.bodAttachedFile = "";
    }
    
    // data를 name value로 수정
    let paramData = [];
    Object.keys(data).map((key)=>{return (
      (key !== 'bodAttachedList') &&
        paramData.push({
          paraName: key, paraValue: data[key]
        })
    )});
    
    let addition = new Addition();
    addition.setCmdName('MOD-NOTICE-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.setParamList(paramData);
    
    return await callCmd(reqInputMsg, 'board')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`수정이 성공하였습니다.`, duration: 2});
            this._viewMode = 'detail';
            this.disNoticeDetail(data.bodId);
            this.disNoticeList();
          } else {
            notification.success({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });

  };

  @action
  delNoticeInfo = async (bodId) => {
    let addition = new Addition();
    addition.setCmdName('DEL-NOTICE-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'bodId', paraValue: bodId});
    
    return await callCmd(reqInputMsg, 'board')
      .then((res) => {
        if (res.error.code === '0000') {
          console.log('res.result[0].resultMsg', res.result[0].resultMsg);
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`삭제가 성공하였습니다.`, duration: 2});
            this._detailData = null;
            this._viewMode = 'list';
            this.disNoticeList();
          } else {
            notification.success({placement: 'bottomLeft', message:`삭제가 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`삭제가 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`삭제가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };
}
  
